export enum Property {
  SCAN_ACTION = 'scanAction',
  INVESTIGATION_STATUS = 'investigationStatus',
  ASSIGNEE = 'assignee',
  PRIORITY = 'priority',
}

export enum Events {
  PROPERTY_CHANGED = 'easmBulkChangePropertyChanged',
}

export enum ErrorCodes {
  TOO_MANY_FINDINGS_PROVIDED_FOR_UPDATE = 3429,
}
